import React from 'react';


export const Image = props => {
	const { src, circle } = props;
	return <img className={`img-responsive${circle ? " circle" : ""}`} src={src} />;
};


// WEBPACK FOOTER //
// src/atoms/lib/Image.js